<template>
	<UnregisteredPageLayout :message="message">
		<form @submit.prevent="submitPassword" name="registerForm">
			<input
				v-if="!message"
				type="password"
				id="password"
				v-model="password"
				required
				placeholder="Type password and press Enter"
			/>
			<button type="submit"/>
		</form>
	</UnregisteredPageLayout>
</template>

<script>
import UnregisteredPageLayout from './_PageLayout.vue'

export default {
	name: 'Register',
	components: {
		UnregisteredPageLayout
	},
	props: {
		invitationToken: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			password: '',
			message: ''
		}
	},
	methods: {
		async submitPassword() {
			if (!this.invitationToken) {
				this.message = 'Invitation token is empty.'
				return
			}
			
			this.message = 'Registering...'
			
			try {
				const response = await this.$api.post('/api/register', {
					invitationToken: this.invitationToken,
					password: this.password
				})

				this.message = response.data.authToken
				localStorage.setItem('authToken', response.data.authToken)
				localStorage.setItem('userEmail', response.data.email)
				this.$router.push({ name: 'Instruction' })
			} catch (error) {
				if (error.response && error.response.status == this.$StatusCodes.CONFLICT) {
					this.message = 'User already exists.'
				} else if (error.response && error.response.status == this.$StatusCodes.NOT_FOUND) {
					this.message = 'Token is not approved or invalid.'
				} else if (error.response && error.response.status == this.$StatusCodes.FORBIDDEN) {
					this.message = 'Password must be at least 8 characters long, not dictionary and not weak.'
				} else {
					this.message = 'An error occurred. Please try again.'
				}
				console.error('Error:', error)
			}
		}
	}
}
</script>

<style scoped>
</style>
